// Bottom tab bar (mobile overhaul Phase 0 §0.4.1; mockup §1.1 A/B). Five
// slots — the four places Henry goes on the move, plus More. Rendered by
// Shell at ≤880px only, as an in-flow flex child AFTER <main>, so the page
// (and any embedded tool iframe) simply gets 84px less height rather than
// having the bar float over it. It stays on /tools/* — with the old topbar
// and drawer gone it is the only way out of an embedded tool.
//
// Badges mirror the sidebar's: tasks and leads are ACTIONABLE counts in the
// alert colour, Projects is the plain active count.

import { NavLink, useLocation } from 'react-router-dom';
import {
  MHomeIcon,
  MLeadsIcon,
  MoreIcon,
  MProjectsIcon,
  MTasksIcon,
} from './icons';
import type { Badges } from './Shell';

const TABS = [
  { to: '/overview', label: 'Overview', icon: MHomeIcon },
  { to: '/tasks', label: 'Tasks', icon: MTasksIcon, badge: 'tasks', alert: true },
  { to: '/leads', label: 'Leads', icon: MLeadsIcon, badge: 'leads', alert: true },
  { to: '/projects', label: 'Projects', icon: MProjectsIcon, badge: 'projects', alert: false },
] as const;

export default function TabBar({
  badges,
  moreOpen,
  onMore,
}: {
  badges: Badges | null;
  /** More is lit while its sheet is open — there's no route behind it. */
  moreOpen: boolean;
  onMore: () => void;
}) {
  const { pathname } = useLocation();
  return (
    <nav className="tabbar" aria-label="Primary">
      {TABS.map((tab) => {
        const count = 'badge' in tab && badges ? badges[tab.badge] : 0;
        return (
          // NavLink's default match covers descendants, so /leads/:id and
          // /projects/:id keep their parent tab lit.
          <NavLink key={tab.to} to={tab.to} replace={tab.to === pathname} className={({ isActive }) => `tb${isActive ? ' on' : ''}`}>
            <tab.icon />
            <span className="tb-label">{tab.label}</span>
            {count > 0 && (
              <span className={`bd${'alert' in tab && tab.alert ? '' : ' plain'}`}>{count}</span>
            )}
          </NavLink>
        );
      })}
      <button
        type="button"
        className={`tb${moreOpen ? ' on' : ''}`}
        data-tabbar-more
        aria-expanded={moreOpen}
        onClick={onMore}
      >
        <MoreIcon />
        <span className="tb-label">More</span>
      </button>
    </nav>
  );
}
